import React, { Component } from 'react';

import FormButton from '../../style/styledComponents/FormButton';
import FormField from '../../style/styledComponents/FormField';
import Icons from '../../style/styledComponents/Icons';
import BoxSize from '../../style/styledComponents/BoxSize';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { verifyGiftCode } from '../../_redux/actions/giftCode';

import Header from '../../Components/Header';
import NavBtn from '../../Components/NavBtn';
import LoadingB from '../../Components/LoadingBeneficiario';

import { setWaitCampaign } from '../../_redux/actions/campaign';

import EpayGirl from '../../img/epayGirl.svg';
import { FiAlertCircle } from 'react-icons/fi';
import { FaExclamation } from 'react-icons/fa';

import stores from '../../utils/stores';

class HomeEpay extends Component {
	constructor(props) {
		super(props);

		this.state = {
			inputData: {
				name: '',
				loja: null
			},
			hasError: false,
			isComplete: false,
			errorOnField: {},
			title: '',
			error: '',
			loading: false
		};

		this.setField = this.setField.bind(this);
		this.validateField = this.validateField.bind(this);
		this.clearErrorOnFocus = this.clearErrorOnFocus.bind(this);
		this.handleIsComplete = this.handleIsComplete.bind(this);
		this.sendCode = this.sendCode.bind(this);
		this.clearError = this.clearError.bind(this);
		this.isComplete = this.isComplete.bind(this);
	}

	componentDidMount() {
		if (window.jQuery) {
			let $ = window.jQuery;
		}
		sessionStorage.setItem('store', stores.epay);
	}
	setField(e) {
		let value = e.target.value;
		let name = e.target.getAttribute('name');

		if (name === 'name') {
			value = value.replace(/( )+/g, '');
		}

		let inputData = { ...this.state.inputData };
		inputData[name] = value;
		this.setState({
			inputData
		});

		this.handleIsComplete(e, 'name');
	}
	clearErrorOnFocus(field) {
		this.setState({
			errorOnField: {
				...this.state.errorOnField,
				[field]: null
			}
		});
	}
	removeWhiteSpace(name, e) {
		this.validateField(e, 'name');
		let value = name.trim();

		let inputData = { ...this.state.inputData };

		inputData['name'] = value;
		this.setState({
			inputData
		});

		this.handleIsComplete();
	}
	validateField(e, field) {
		const errorMsgs = {
			name: 'Código inválido'
		};

		const isValid = this.checkField(field, e.target.value);
		if (isValid) {
			this.setState({
				errorOnField: { ...this.state.errorOnField, [field]: null },
				isComplete: true
			});
		} else {
			this.setState({
				errorOnField: {
					...this.state.errorOnField,
					[field]: errorMsgs[field]
				}
			});
		}

		this.handleIsComplete(e, 'name');

		//if (!this.state.hasMoreThanOneSub) {
		//}
	}
	handleIsComplete(e, field) {
		const isIncomplete = this.checkField(field, e.target.value);

		if (isIncomplete) {
			this.setState({
				isComplete: true
			});
		} else {
			this.setState({
				isComplete: false
			});
		}
	}

	checkField(name, value) {
		let isValidField = false;
		let checkField = {
			//name: /^[a-z\d]{12}$/i
			name: /^[a-z\d]{12}$/i
			//name: /^([^\d\s]+)\s([^\d\s]+).*$/i
		};

		if (checkField[name].test(value)) {
			isValidField = true;
		} else isValidField = false;

		return isValidField;
	}

	sendCode() {
		//let loja = this.props.match.params;
		let loja = 'epay';
		this.setState({
			loading: true
		});
		var result = this.props.verifyGiftCode(this.state.inputData.name);
		result.then(valor => {
			if (valor === false) {
				this.setState({
					loading: false
				});
				this.props.history.push(process.env.PUBLIC_URL + `/${loja}/bem-vindo`);
			} else if (valor === true) {
				this.setState({
					hasError: true,
					loading: false,
					title: 'Ops!',
					error:
						'Tivemos um problema com o servidor. Tente novamente mais tarde, ou entre em contato com a nossa central.'
				});
				//TODO fazer a separação de erro do server pro erro de código
			} else if (valor === 'true1') {
				this.setState({
					hasError: true,
					loading: false,
					title: 'Código digitado inválido',
					error:
						'O código digitado não existe ou já foi resgatado. Se você tiver qualquer dúvida, entre em contato conosco pela nossa central de atendimento.'
				});
			}
		});
	}

	clearError() {
		this.setState({
			hasError: null
		});
	}
	isComplete() {
		if (this.state.inputData.name.length < 12) {
			this.setState({
				errorOnField: {
					...this.state.errorOnField,
					'name': 'Código inválido'
				}
			});
		} else {
		}
	}
	render() {
		let errorElm = null;

		if (this.state.hasError) {
			errorElm = (
				<div className='overlay'>
					<FormButton className='overlay-box'>
						<BoxSize className='overlay-box--content-epay'>
							<div className='title-alert2'>
								<Icons className='icon-container2'>
									<FaExclamation color={'white'} size={16} />
								</Icons>
								<h2>{this.state.title}</h2>
							</div>
							<p>{this.state.error} </p>
						</BoxSize>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-ok-epay'
								onClick={this.clearError}>
								TENTAR NOVAMENTE
							</button>
						</div>
					</FormButton>
				</div>
			);
		}

		return (
			<div className='page-wrapper'>
				<div className=' footer-adjustment'>
					{errorElm}
					<Header {...this.props} />
					<BoxSize className=''>
						<div className='content-align'>
							<h2>Bem-vindo à YALO!</h2>
							<div className='visible-xs visible-sm'>
								<p>
									Com o código que você tem em mãos vamos resgatar e ativar sua
									assinatura. É muito rápido e fácil! Já já você vai estar com
									seus benefícios ativos.
								</p>
							</div>
							<div className='row visible-md visible-lg'>
								<p>
									Com o código que você tem em mãos vamos resgatar e ativar sua
									assinatura.
									<br /> É muito rápido e fácil! Já já você vai estar com seus
									benefícios ativos.
								</p>
							</div>
						</div>
					</BoxSize>
					<BoxSize className=''>
						<div className='box-content-group'>
							<img src={EpayGirl}></img>

							<FormField className=''>
								<div className='form-group2 form-container'>
									<input
										maxLength='12'
										//maxLength='30'
										type='text'
										className='form-control2'
										required
										id='nome'
										name='name'
										onChange={this.setField}
										onFocus={() => this.clearErrorOnFocus('name')}
										onBlur={e => this.validateField(e, 'name')}
										value={this.state.inputData.name}
									/>
									<label htmlFor='nome'>Cupom Yalo</label>
									{this.state.errorOnField.name && (
										<div className='error-msg'>
											<FiAlertCircle size={13} color={'red'} />
											<small className='credit-card-error'>
												{this.state.errorOnField.name || 'Código inválido'}
											</small>
										</div>
									)}
								</div>
							</FormField>
							{!this.state.isComplete ? (
								<NavBtn
									disabled={!this.state.isComplete}
									goForward={this.isComplete}
									goForwardText={'RESGATAR MINHA ASSINATURA'}
									step={true}></NavBtn>
							) : this.state.loading ? (
								<div className='loading-beneficiario2'>
									<LoadingB type='spin' color='gray' size={25} />
									<span>Carregando...</span>
								</div>
							) : (
								<NavBtn
									disabled={this.state.isLoading}
									goForward={this.sendCode}
									goForwardText={'RESGATAR MINHA ASSINATURA'}
									step={true}></NavBtn>
							)}
						</div>
					</BoxSize>
				</div>
				<div className='container-fluid'></div>
			</div>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ setWaitCampaign, verifyGiftCode }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HomeEpay);
